// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // baseApiUrl: "https://localhost:5001/api",
  // baseUrl: "https://localhost:5001",
  baseApiUrl: "https://joblingapi.azurewebsites.net/api",
  baseUrl: "https://joblingapi.azurewebsites.net",
  baseApiKey: "7ddc578c-7584-4fdb-bb66-d9a67add878f",
  firebaseConfig: {
    apiKey: "AIzaSyDiTm-zL9VfDKTXlPcRBe0-9mXpe9ASk8M",
    authDomain: "manzoul-chat.firebaseapp.com",
    databaseURL: "https://manzoul-chat-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "manzoul-chat",
    storageBucket: "manzoul-chat.appspot.com",
    messagingSenderId: "1099027930584",
    appId: "1:1099027930584:web:c7fd414c5d11c5b00e26ad",
    measurementId: "G-7H56MBQH6R"
  },
  paypalConfig: {
    clientId: "ATeCib5NKrEy1CssCUxbaZgRxZeeVjL17aM9h9eNLq3W_6jQqiyoWHLMsKO-LfO5v-axikHjmY6Q5MiK",
    currency: "USD"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
